import { useTranslations } from "next-intl";

import { FolderTreeDialog } from "@/components/expense/fields/FolderTreeDialog";
import { FormItem, FormLabel } from "@/components/ui/form";

interface IFolderSelectorProps {
    isPending: boolean;
    value: string | undefined;
    onChange: (currency: string | undefined) => void;
}

export const FolderSelector = ({ value, onChange, isPending }: IFolderSelectorProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("folder")} :</FormLabel>
            <div className="w-full md:w-1/2">
                <FolderTreeDialog value={ value } onChange={ onChange } isPending={ isPending } />
            </div>
        </FormItem>
    );
};
